var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "TcMyAppointments" },
    [
      _c("nav", { staticClass: "tabs mt-5" }, [
        _c(
          "span",
          {
            staticClass: "tab",
            on: {
              click: function($event) {
                return _vm.$root.setPage("new-appointment")
              }
            }
          },
          [_vm._v("Solicitar cita")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "tab active" }, [_vm._v("Ver mis citas")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "appointments-list mt-12" },
        [
          _vm._l(_vm.appointments, function(appo) {
            return _c(
              "div",
              {
                key: appo.id,
                staticClass:
                  "appointment w-2/4 mx-auto bg-white px-5 pt-10 pb-5 mb-5 rounded-xl shadow-md",
                style: {
                  "border-left":
                    "4px solid " + _vm.$root.delegationColor(appo.delegation_id)
                }
              },
              [
                _c("div", { staticClass: "flex" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "h-8 w-8",
                      style: {
                        color: _vm.$root.delegationColor(appo.delegation_id)
                      },
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        fill: "none",
                        viewBox: "0 0 24 24"
                      }
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "12",
                          cy: "12",
                          r: "12",
                          fill: "currentColor"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pl-5 flex-grow" }, [
                    _c("h3", { staticClass: "text-2xl mb-3" }, [
                      _vm._v(_vm._s(appo.delegation_name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon_with_text mb-1" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "h-6 w-6 text-primary",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d:
                                "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(appo.reserved_at.toDate()))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon_with_text mb-1" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "h-6 w-6 text-primary",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(appo.reserved_at.toTime()))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "icon_with_text mb-1" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "h-6 w-6 text-primary",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }
                        },
                        [
                          appo.type == "phone_call"
                            ? _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d:
                                    "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          appo.type != "phone_call"
                            ? _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d:
                                    "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          appo.type != "phone_call"
                            ? _c("path", {
                                attrs: {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            appo.type == "phone_call"
                              ? "Telefónica"
                              : "Presencial"
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-6" }, [
                      _c("h4", { staticClass: "font-bold" }, [
                        _vm._v("Observaciones:")
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(appo.reason))])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "mt-12 bg-white hover:text-white border-primary text-primary mx-auto px-10 w-1/2 py-2 text-xl",
                    on: {
                      click: function($event) {
                        return _vm.cancelAppointment(appo.id)
                      }
                    }
                  },
                  [_vm._v("\n        Cancelar cita\n      ")]
                )
              ]
            )
          }),
          _vm._v(" "),
          _vm.appointments.length == 0
            ? _c("div", [
                _c("h2", { staticClass: "text-center" }, [
                  _vm._v("EN ESTE MOMENTO NO TIENE CITAS PENDIENTES")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-center mt-6" }, [
                  _c(
                    "a",
                    {
                      staticClass: "text-primary",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          return _vm.$root.setPage("new-appointment")
                        }
                      }
                    },
                    [_vm._v("Solicitar cita")]
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.canceling
        ? _c("tc-cancel-appointment", {
            attrs: { appointment: _vm.selectedAppointment }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }